// $route
import { computed, ComputedRef } from 'vue'
import { useRoute, RouteLocationNormalizedLoaded, RouteParams, LocationQuery, RouteRecordName } from 'vue-router'

export default function getRoute(): {
  route: RouteLocationNormalizedLoaded,
  query: ComputedRef<RouteParams>
  params: ComputedRef<LocationQuery>
  name: ComputedRef<RouteRecordName>
} {
  const $route: RouteLocationNormalizedLoaded = useRoute()
  const params: ComputedRef<RouteParams> = computed(() => $route.params)
  const query: ComputedRef<LocationQuery> = computed(() => $route.query)
  const name: ComputedRef<RouteRecordName> = computed(() => $route.name)
  return {
    route: $route,
    query,
    params,
    name
  }
}
